import PropTypes from 'prop-types';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';

import { bemModifier } from 'utils/BEMHelper';

import styles from './ShareableReportSectionCell.scss';

const ShareableReportSectionCell = (props) => {
  const { fluid, hidden, children, noBorder, className, hiddenOnPrint } = props;

  const styleName = classNames(
    ...bemModifier('m-shareable-report-section-cell', {
      fluid,
      hidden,
      'no-border': noBorder,
      'hide-on-print': hiddenOnPrint,
    }),
  );

  return (
    <div styleName={styleName} className={className}>
      {children}
    </div>
  );
};

ShareableReportSectionCell.propTypes = {
  hidden: PropTypes.bool,
  noBorder: PropTypes.bool,
  fluid: PropTypes.bool,
  hiddenOnPrint: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

ShareableReportSectionCell.defaultProps = {
  hiddenOnPrint: false,
};

export default CSSModules(ShareableReportSectionCell, styles, { allowMultiple: true });
